// Registers Core Web Vitals and forwards them as `web_vital` product events.
// Loaded from WebVitals.tsx (client island) after PostHog init.

import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { EVENTS, track } from '@/lib/analytics';

function emit(metric: Metric): void {
  track(EVENTS.web_vital, {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    navigation_type: metric.navigationType,
  });
}

/** Subscribe to LCP / INP / CLS / TTFB / FCP once per page load. */
export function registerWebVitals(): void {
  onLCP(emit);
  onINP(emit);
  onCLS(emit);
  onTTFB(emit);
  onFCP(emit);
}
